var map = {
	"./banner0-back.png": "dad1",
	"./banner0.png": "17d3",
	"./banner1.png": "d969",
	"./banner2.png": "fab0",
	"./banner3.png": "60b3",
	"./banner4.png": "8a09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "284d";